import { render } from "./taxStatistics.vue?vue&type=template&id=40ec37f8&scoped=true"
import script from "./taxStatistics.vue?vue&type=script&lang=js"
export * from "./taxStatistics.vue?vue&type=script&lang=js"

import "./taxStatistics.vue?vue&type=style&index=0&id=40ec37f8&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40ec37f8"]])

export default __exports__